
import AreaBase from './areabase';
import ColumnDataset from '../_internal/datasets/column';
import AreaDataset from '../_internal/datasets/area';
import LineDataset from '../_internal/datasets/line';
import SplineAreaDataset from '../_internal/datasets/mssplinearea';
import SplineLineDataset from '../_internal/datasets/msspline';
import ColumnMultiSeriesGroup from '../_internal/datasets/groups/column.multiseries';
import datasetFactory from '../_internal/factories/combi-dual-y-dataset';

var UNDEFINED;

class MSCombi2D extends AreaBase {
  /**
   * constructor fn
   */
  constructor () {
    super();
    this.registerFactory('dataset', datasetFactory, ['vCanvas']);
  }
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'MSCombi2D';
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'MSCombi2D';
  }
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.friendlyName = 'Multi-series Combination Chart';
    config.defaultDatasetType = 'column';
    config.enablemousetracking = true;
    config.showzeroplaneontop = 0;
  }
  /**
   * This method return the dataset definations for this charts
   * @param  {string} name type of dataset class
   * @return {Object}      dataset class
   */
  getDSdef (name) {
    if (name === 'splinearea') {
      return SplineAreaDataset;
    } else if (name === 'spline') {
      return SplineLineDataset;
    } else if (name === 'area') {
      return AreaDataset;
    } else if (name === 'line') {
      return LineDataset;
    }
    return ColumnDataset;
  }
  /**
   * This method return the dataset-group definations for this charts
   * @param  {string} name is type of dataset group
   * @return {Object} <dataset group class>     dataset group class
   */
  getDSGroupdef (name) {
    return name === 'column' ? ColumnMultiSeriesGroup : UNDEFINED;
  }
  /**
   * function to return dataset type applicable for this chart
   * @param   {string}  name  dataset type
   * @return  {string}        dataset type applicable for this chart
   */
  getDSType (name = '') {
    if (name.toLowerCase() === 'splinearea') {
      return 'splinearea';
    } else if (name.toLowerCase() === 'spline') {
      return 'spline';
    } else if (name.toLowerCase() === 'area') {
      return 'area';
    } else if (name.toLowerCase() === 'line') {
      return 'line';
    }
    return 'column';
  }
}
export default MSCombi2D;
